import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import AsyncTableComponent from '../Table/AsyncTableContainer';

import { formatNumber, isAdmin } from '../../utils';
import { getExportTitle } from '../ViewExport/utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../Table/constants';

import { DATE_RANGES_TYPES, TABLE_DATA_TYPES } from '../../staticData';
import AdminAction from '../AdminAction';
import StyledLink from '../StyledLink';
import ListActions from '../Table/ListActions';
import { limitFilter } from '../Table/filters';
import PMCListExport from './PMCListExport';

const PMCListComponent = (props) => {
  const { t } = useTransl();
  const theme = useTheme();
  const { items, getItems, onPmcDelete, listParams, listKey, onExport } = props;
  const columns = [
    {
      Header: t('title.name'),
      id: 'name',
      accessor: ({ id, name }) => (
        <StyledLink to={`/pmc/${id}/buildings`}>{name}</StyledLink>
      ),
      headerClassName: 'sort',
      filter: true,
    },
    {
      Header: t('title.buildings'),
      id: 'buildings_count',
      accessor: 'buildingsCount',
      headerClassName: 'sort',
    },
    {
      Header: <AdminAction>{t('title.monthlyBill')}</AdminAction>,
      id: 'monthly_bill',
      accessor: ({ monthlyBill }) =>
        monthlyBill && `$${formatNumber(monthlyBill)}`,
      headerClassName: 'sort',
      show: isAdmin(),
      filter: true,
    },
    {
      Header: t('title.actions'),
      id: 'actions',
      fixed: 'right',
      sortable: false,
      width: 120,
      accessor: (entry) => {
        let actions = [];
        const adminActions = [
          {
            label: t('actions.remove'),
            color: theme.palette.secondary.main,
            onClick: () => onPmcDelete(entry, listParams),
            isFullWidth: true,
          },
        ];
        if (isAdmin()) {
          actions = actions.concat(adminActions);
        }
        return <ListActions actions={actions} isFullWidth />;
      },
    },
  ];

  const filters = [limitFilter(listParams)];
  const tableDataType = TABLE_DATA_TYPES.pmcs;
  const defaultParams = {
    ordering: 'name',
  };

  const action = isAdmin()
    ? [
        {
          label: t('pmc.createPmc'),
          url: `/pmc/create`,
        },
      ]
    : [];

  const title = isAdmin() ? t('pmcSettings.pmc') : t('pmc.myManagementCompany');
  const exportTitle = getExportTitle(title, null, null);
  const exportActions = (
    <PMCListExport
      title={exportTitle}
      getDataForExport={onExport}
      columns={columns}
    />
  );

  return (
    <AsyncTableComponent
      tableId={TABLE_ID.pmcListTable}
      title={title}
      items={items}
      columns={columns}
      defaultSort={TABLE_CONSTANTS.name}
      defaultSortDesc={false}
      manual
      filters={filters}
      onLoad={() => {}}
      getItems={getItems}
      listParams={listParams}
      defaultParams={defaultParams}
      tableDataType={tableDataType}
      listKey={listKey}
      action={<ListActions actions={action} />}
      dateRangeType={DATE_RANGES_TYPES.created_at}
      datePicker
      showFiltersAreApplied={false}
      exportActions={exportActions}
    />
  );
};

PMCListComponent.propTypes = {
  items: PropTypes.instanceOf(Object).isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  getItems: PropTypes.func.isRequired,
  listKey: PropTypes.string.isRequired,
  onExport: PropTypes.func.isRequired,
  onPmcDelete: PropTypes.func.isRequired,
};

export default PMCListComponent;
